document.addEventListener("DOMContentLoaded", function () {
  /* --------- Mega Menu Hover (Desktop) & Click (Mobile) --------- */
  document.querySelectorAll("[data-megamenu-trigger]").forEach((trigger) => {
    const menuId = trigger.getAttribute("data-megamenu-trigger");
    const menu = document.getElementById(menuId);
    if (!menu) return;

    const hasChildren = menu.querySelector(
      ".mega-menu-col, .mega-menu-sellers"
    );
    const dropdownIcon = trigger.querySelector(".dropdown-icon");


    if (!hasChildren && dropdownIcon) {
      dropdownIcon.style.display = "none";
    }

    if (window.innerWidth < 18) {
      // Mobile: toggle con click
      let isOpen = false;

      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        const isVisible = !menu.classList.contains("hidden");

        document
          .querySelectorAll(".mega-menu-overlay.flex")
          .forEach((openMenu) => {
            openMenu.classList.add("hidden");
            openMenu.classList.remove("flex");
          });

        if (!isVisible) {
          menu.classList.remove("hidden");
          menu.classList.add("flex");
          isOpen = true;
        } else {
          menu.classList.add("hidden");
          menu.classList.remove("flex");
          isOpen = false;
        }
      });

      document.addEventListener("click", (e) => {
        if (!trigger.contains(e.target) && !menu.contains(e.target)) {
          menu.classList.add("hidden");
          menu.classList.remove("flex");
          isOpen = false;
        }
      });
    } else {
      // Desktop: hover
      let isOverTrigger = false;
      let isOverMenu = false;

      const showMenu = () => {
        isOverTrigger = true;
        menu.classList.remove("hidden");
        menu.classList.add("flex");
      };

      const hideMenu = () => {
        isOverTrigger = false;
        setTimeout(() => {
          if (!isOverMenu) {
            menu.classList.add("hidden");
            menu.classList.remove("flex");
          }
        }, 150);
      };

      trigger.addEventListener("mouseenter", showMenu);
      trigger.addEventListener("mouseleave", hideMenu);
      menu.addEventListener("mouseenter", () => (isOverMenu = true));
      menu.addEventListener("mouseleave", () => {
        isOverMenu = false;
        if (!isOverTrigger) hideMenu();
      });
    }
  });

  /* --------- Mega Menu Dynamic Content (First Group Only) --------- */
  const img = document.getElementById("mega-product-img");
  const title = document.getElementById("mega-product-title");
  const desc = document.getElementById("mega-product-desc");
  const ratingContainer = document.getElementById("mega-product-rating");

  const defaultImg = img.getAttribute("src");
  const defaultTitle = title.innerHTML;
  const defaultDesc = desc.textContent;

  const generateSVGStars = (average) => {
    const fullStars = Math.floor(average);
    const percentage = (average*100)/5;
    return `
    <div data-oke-star-rating="" data-oke-reviews-product-id="shopify-7765828141241" data-oke-rendered="">
    <div data-oke-reviews-version="0.80.1" data-oke-container="" class="okeReviews oke-sr">
        <div class="">
            <div class="oke-sr-stars">
                <div class="oke-stars"><!---->
                    <div class="oke-stars-background"><svg height="18" viewBox="0 0 79.22222222222221 14"
                            aria-hidden="true" role="none">
                            <use x="0" href="#oke-star-empty"></use>
                            <use x="16.155555555555555" href="#oke-star-empty"></use>
                            <use x="32.31111111111111" href="#oke-star-empty"></use>
                            <use x="48.46666666666667" href="#oke-star-empty"></use>
                            <use x="64.62222222222222" href="#oke-star-empty"></use>
                        </svg></div>
                    <div class="oke-stars-foreground" style="width: ${percentage}%;"><svg height="18"
                            viewBox="0 0 79.22222222222221 14" aria-hidden="true" role="none">
                            <use x="0" href="#oke-star-filled"></use>
                            <use x="16.155555555555555" href="#oke-star-filled"></use>
                            <use x="32.31111111111111" href="#oke-star-filled"></use>
                            <use x="48.46666666666667" href="#oke-star-filled"></use>
                            <use x="64.62222222222222" href="#oke-star-filled"></use>
                        </svg></div>
                </div>
            </div>
            
    </div>
</div>
    `;
  };

  const updateMegaMenuContent = (link) => {
    const newImg = link.dataset.img;
    const newTitle = link.dataset.title;
    const newDesc = JSON.parse(link.dataset.desc).children[0].children[0].value;
    const rating = parseFloat(link.dataset.rating);
    const reviews = link.dataset.reviews;

    img.src = newImg && newImg !== "null" ? newImg : defaultImg;
    title.innerHTML = newTitle || defaultTitle;
    desc.textContent = newDesc && newDesc !== "null" ? newDesc : defaultDesc;

    if (rating && reviews) {
      const svg = generateSVGStars(rating);
      const locale = document.documentElement.lang;
      const label = locale === "en" ? "reviews" : "beoordelingen";
      const formatted =
        locale === "en"
          ? rating.toFixed(1).replace(",", ".")
          : rating.toFixed(1).replace(".", ",");

      ratingContainer.innerHTML = `
      <div class="flex mt-[8px] items-center gap-[11px]">
        <div class="flex gap-[2px]">${svg}</div>
        <p class="before:h-[17px] before:w-[1px] before:bg-[#0c392b] before:content-[''] flex items-center gap-[10px] text-[#0c392b] font-bold text-[14px] sm:text-[16px] leading-[130%]">
          ${formatted}/5 (${reviews} ${label})
        </p>
      </div>
    `;
      ratingContainer.classList.remove("hidden");
    } else {
      ratingContainer.classList.add("hidden");
      ratingContainer.innerHTML = "";
    }
  };

  const firstGroup = document.querySelector(
    ".mega-menu-columns .mega-menu-col ul"
  );
  if (firstGroup) {
    const links = firstGroup.querySelectorAll(".mega-menu-item");

    links.forEach((link) => {
      const isDefaultItem = link
        .getAttribute("href")
        ?.includes("/collections/all?category");

      link.addEventListener("mouseenter", () => {
        if (isDefaultItem) {
          img.src = defaultImg;
          title.innerHTML = defaultTitle;
          desc.textContent = defaultDesc;
          ratingContainer.classList.add("hidden");
          ratingContainer.innerHTML = "";
        } else {
          updateMegaMenuContent(link);
        }
      });

      link.addEventListener("mouseleave", () => {
        img.src = defaultImg;
        title.innerHTML = defaultTitle;
        desc.textContent = defaultDesc;
        ratingContainer.classList.add("hidden");
        ratingContainer.innerHTML = "";
      });
    });
  }

  /* --------- Best Seller Section --------- */
  document
    .querySelectorAll("#megamenu-2 .mega-menu-product")
    .forEach((product) => {
      const link = product.querySelector(".bestseller-link");
      const ratingContainer = product.querySelector(
        ".mega-menu-product-rating"
      );
      if (!link || !ratingContainer) return;

      const rating = parseFloat(link.dataset.rating);
      let reviews = link.dataset.reviews;

      if ((!reviews || reviews === "") && link.dataset.rating) {
        const match = link.dataset.rating.match(/\/5\s*([\d.,+ ]+)/);
        if (match) {
          reviews = match[1].trim();
        }
      }

      if (reviews) {
        reviews = reviews.replace(/[^0-9,+]/g, "").trim();
      }

      const lang = document.documentElement.lang;
      let reviewsLabel = "reviews";
      if (lang.startsWith("nl")) {
        reviewsLabel = "beoordelingen";
      } else if (lang.startsWith("de")) {
        reviewsLabel = "Bewertungen";
      } else if (lang.startsWith("fr")) {
        reviewsLabel = "avis";
      }

      if (!isNaN(rating)) {
        const svg = generateSVGStars(rating);
        const formatted =
          lang.startsWith("nl") ||
          lang.startsWith("fr") ||
          lang.startsWith("de")
            ? rating.toFixed(1).replace(".", ",")
            : rating.toFixed(1).replace(",", ".");

        ratingContainer.innerHTML = `
      <div class="flex mt-[8px] items-center gap-[11px]">
        <div class="flex gap-[2px]">${svg}</div>
        <p class="before:h-[17px] before:w-[1px] before:bg-[#0c392b] before:content-[''] flex items-center gap-[10px] text-[#0c392b] font-bold text-[14px] sm:text-[16px] leading-[130%]">
          ${formatted}/5${
          reviews ? " (" + reviews + " " + reviewsLabel + ")" : ""
        }
        </p>
      </div>
    `;
        ratingContainer.style.display = "block";
      } else {
        ratingContainer.innerHTML = "";
        ratingContainer.style.display = "none";
      }
    });

  /* --------- Carousel Scroll --------- */
  const carousel = document.getElementById("bestCarousel");
  const prevBtn = document.getElementById("bestPrev");
  const nextBtn = document.getElementById("bestNext");
  const scrollAmount = 170;

  if (carousel) {
    nextBtn?.addEventListener("click", () => {
      carousel.scrollBy({ left: scrollAmount, behavior: "smooth" });
    });
    prevBtn?.addEventListener("click", () => {
      carousel.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    });
  }

  /* --------- Hide Restricted Products by Country --------- */
  const restrictedHandles = ["hormone-balance-blend-pdp"];
  const userCountry = typeof Shopify !== "undefined" ? Shopify.country : null;

  if (userCountry && userCountry !== "US") {
    restrictedHandles.forEach((handle) => {
      const restrictedLinks = document.querySelectorAll(
        `.mega-menu-item[data-handle="${handle}"]`
      );
      restrictedLinks.forEach((link) => {
        const li = link.closest("li");
        if (li) li.style.display = "none";
      });
    });
  }
});
